export default __webpack_public_path__ + "static/media/mapFrameSmallBlack.5cdefc73.png";